import React from 'react'
import TradingViewChart from '../../components/charts/RealtimeTrdingChart'

export default function Chart() {
  return (
    <TradingViewChart sx={{ position: 'relative' }} />
  )
}
